import ModalBox from "components/Modal";
import type { TMissingInfos } from "components/shared/BPNavigationBarSettings";
import { SmallBodyHighlight } from "helpers/TypographyComponents";
import { useTranslation } from "react-i18next";
import { ICustomField } from "store/customFieldsStore";

import styles from "./style.module.scss";

interface IMissingInfosModal {
    open: boolean;
    onClose: () => void;
    /**
     * Missing informations fields
     */
    missingInfos?: TMissingInfos;
    /**
     * From which page the modal is called
     */
    from: "account" | "tax" | "settings-nav";
}

const MissingInfosModal = ({ open, onClose, missingInfos, from }: IMissingInfosModal) => {
    const [t] = useTranslation();
    const showAccountFields = from === "account" || from === "settings-nav";
    const showTaxFields = from === "tax" || from === "settings-nav";

    return (
        <ModalBox
            open={open}
            onClose={onClose}
            mainTitle={t("NewBeneficiary.IncompleteProfile")}
            subTitle={t("NewBeneficiary.CompleteFollowingFields")}
        >
            <div className={styles["missing-infos-modal"]}>
                <div className={styles["missing-infos-modal-body"]}>
                    {showAccountFields && !!missingInfos?.account?.length && (
                        <div className={styles["missing-infos-modal-account"]}>
                            <SmallBodyHighlight>{t("Settings.Account")}</SmallBodyHighlight>
                            <div className={styles["missing-infos-modal-account-fields"]}>
                                {missingInfos?.account.map((fieldName) => (
                                    <div key={`bp-missing-info-${fieldName}`} className={styles["field-name"]}>
                                        {fieldName}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    {showTaxFields && !!missingInfos?.tax?.length && (
                        <div className={styles["missing-infos-modal-tax"]}>
                            <SmallBodyHighlight>{t("NewBeneficiary.Profile")}</SmallBodyHighlight>
                            <div className={styles["missing-infos-modal-account-fields"]}>
                                {missingInfos?.tax.map((field) => (
                                    <div key={`bp-missing-info-${field.name}`} className={styles["field-name"]}>
                                        {field.name}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </ModalBox>
    );
};

export default MissingInfosModal;
